import React from 'react';
import { PageSizeButton, PageSizeContainer } from './PageSizeSelector.styled';
import {Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";

interface PageSizeSelectorProps {
    options: number[];
    selectedSize: number;
    onChange: (size: number) => void;
    ariaLabelGroup?: string;
    getSizeAriaLabel?: (size: number) => string;
}

const PageSizeSelector = ({
    options,
    selectedSize,
    onChange,
    ariaLabelGroup,
    getSizeAriaLabel,
}: PageSizeSelectorProps) => {
    const {t} = useTranslation();
    return (
        <PageSizeContainer role="group" aria-label={ariaLabelGroup}>
            {options.map(size => (
                <Tooltip key={size} title={`${t('sidebar.setPageSizeTo')} ${size}`}>
                    <PageSizeButton
                        $isSelected={size === selectedSize}
                        onClick={() => onChange(size)}
                        aria-pressed={size === selectedSize}
                        aria-label={getSizeAriaLabel ? getSizeAriaLabel(size) : String(size)}
                    >
                        {size}
                    </PageSizeButton>
                </Tooltip>
            ))}
        </PageSizeContainer>
    );
};

export default PageSizeSelector;
